//内容分类词典
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Popconfirm,
  Row,
  Table,
  Typography,
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useForm } from 'antd/es/form/Form'
import React, { useEffect, useState } from 'react'
import SecondDictionary from './secondDictionary/secondDictionary'
import {
  deleteCategories,
  deleteMarketCategories,
  getCategories,
  getMarketCategories,
  postCategories,
  postMarketCategories,
  putCategories,
  putMarketCategories,
} from '../../api/api'

const SecondHandDictionary = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [dictionary, setDictionary] = useState([]) //字典
  const [isFresh, setIsFresh] = useState(false)
  useEffect(() => {
    //获取初始字典初始数据
    getMarketCategories({}).then((res) => {
      setDictionary(res.data.data.rows)
      const maxid = res.data.data.rows.reduce((cur, pre) => {
        return pre.id > cur.id ? pre : cur
      })
      // console.log(maxid)
      setCount(maxid.id + 1)
    })
  }, [isFresh])

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode = <Input />
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `请输入 ${title}!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    )
  }

  const [form] = Form.useForm()
  const [count, setCount] = useState(0)
  const [editingKey, setEditingKey] = useState('')
  const [isNew, setIsNew] = useState(false) //判断是新增还是修改
  const isEditing = (record) => record.id === editingKey
  const [isInEditing, setIsInediting] = useState(false) //判断是否正在进行编辑
  //按编辑后的调用
  const edit = (record) => {
    console.log('record', record)
    setIsNew(false)
    form.setFieldsValue({
      id: '',
      name: '',
      ...record,
    })
    setEditingKey(record.id)
  }

  //点击取消时的回调
  const cancel = (k) => {
    // console.log(editingKey);
    setEditingKey('')
    setIsInediting(false)
    if (isNew) {
      //如果是新增就进行删除新增行的操作，如果不是新增就是删除，那么就不进行改操作
      if (isNew) {
        //如果是新增就进行删除新增行的操作，如果不是新增就是删除，那么就不进行改操作
        const newData = dictionary.filter((item) => item.id !== editingKey)
        setDictionary(newData)
      }
    }
  }

  //按保存时的调用
  const save = async (key) => {
    try {
      const row = await form.validateFields()
      const newData = [...dictionary]
      const index = newData.findIndex((item) => key === item.id)
      if (index > -1) {
        const item = newData[index]
        newData.splice(index, 1, {
          ...item,
          ...row,
        })
        setDictionary(newData)

        setEditingKey('')
      } else {
        newData.push(row)
        setDictionary(newData)
        setEditingKey('')
      }
      const postParam = {
        //定义新增数据参数
        superior_id: 0,
        name: row.name,
        // type: Number(localStorage.getItem('contentType')),
      }
      const putParam = {
        //定义新增数据参数
        superior_id: 0,
        name: row.name,
        id: editingKey,
        // type: Number(localStorage.getItem('contentType')),
      }
      isNew
        ? //上传新增数据
          postMarketCategories(postParam).then((res) => {
            message.success('内容分类新增成功！')
            setIsInediting(false)
            setIsFresh((pre) => !pre)
          })
        : //上传修改数据
          putMarketCategories(putParam).then((res) => {
            message.success('内容分类修改成功！')
            setIsInediting(false)
            setIsFresh((pre) => !pre)
          })
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo)
    }
  }

  //删除操作的调用
  const handleDelete = (key) => {
    deleteMarketCategories(key).then((res) => {
      const code = res.data.code
      // console.log(code);
      if (code === 1008) {
        message.error('存在内容，不能删除！')
      } else if (code === 1007) {
        message.error('存在二级分类，不能删除！')
      } else if (code === 0) {
        //返回0的时候表示正常删除
        message.success('内容分类删除成功！')
        const newData = dictionary.filter((item) => item.id !== key)
        console.log('delete', newData)
        setDictionary(newData)
        setCount(count - 1)
        setIsInediting(false)
      } else if (code ?? true) {
        //返回null的时候表示正常删除
        const newData = dictionary.filter((item) => item.id !== key)
        console.log('delete', newData)
        setDictionary(newData)
        setCount(count - 1)
        setIsInediting(false)
      }
    })
  }

  //新增行的调用
  const handleAdd = () => {
    if (isInEditing) {
      Modal.info({ content: '请先完成现在的编辑' })
      return
    }
    const newData = {
      id: count,
      name: ' ',
    }
    console.log('newDictionary', [...dictionary, newData])
    setDictionary([...dictionary, newData])
    //让新增的行为可编辑状态
    setEditingKey(count)
    setCount(count + 1)
    setIsNew(true)
    setIsInediting(true)
    let editInputItem = document.querySelector(
      '.ant-table-cell .ant-form-item-control-input-content .ant-input'
    )
    // editInputItem.setAttribute('value', '')
    console.log('editInputItem', editInputItem)
  }

  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
      width: '25%',
      // editable: true,
    },
    {
      title: '分类名称',
      dataIndex: 'name',
      width: '55%',
      editable: true,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      render: (_, record) => {
        // console.log(record);
        const editable = isEditing(record)
        return editable ? (
          <Row>
            <Col span={12}>
              {' '}
              <Typography.Link
                onClick={() => save(record.id)}
                style={{
                  marginRight: 8,
                }}
              >
                保存
              </Typography.Link>
            </Col>
            <Col span={12}>
              <Popconfirm title="确认取消编辑?" onConfirm={cancel}>
                <a>取消</a>
              </Popconfirm>
            </Col>
          </Row>
        ) : (
          <Row>
            {/* <Col span={8}>
              <SecondDictionary
                firstCategory={record}
                count={count}
                setIsFresh={setIsFresh}
              />
            </Col> */}
            <Col span={8}>
              {' '}
              <Typography.Link
                disabled={editingKey !== ''}
                onClick={() => edit(record)}
              >
                编辑
              </Typography.Link>
            </Col>
            <Col span={8}>
              <Popconfirm
                title="确认删除?"
                onConfirm={() => handleDelete(record.id)}
              >
                <Typography.Link disabled={editingKey !== ''}>
                  删除
                </Typography.Link>
              </Popconfirm>
            </Col>
          </Row>
        )
      },
    },
  ]

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'content' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    }
  })

  const showModal = () => {
    setIsModalOpen(true)
  }

  // const handleOk = () => {
  //       setIsModalOpen(false)
  // };
  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  }
  return (
    <>
      <a onClick={showModal}>内容分类字典</a>
      <Modal
        title="内容分类字典"
        open={isModalOpen}
        // onOk={handleOk}
        onCancel={handleCancel}
        footer={
          [] // 设置footer为空，去掉 取消 确定默认按钮
        }
        width={'800px'}
      >
        <Form form={form} component={false}>
          <Table
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            bordered
            dataSource={dictionary}
            columns={mergedColumns}
            rowClassName="editable-row"
            pagination={false}
          />
          <Button
            type="dashed"
            onClick={handleAdd}
            block
            icon={<PlusOutlined />}
            style={{ marginTop: '30px' }}
          >
            新增一级分类
          </Button>
        </Form>
      </Modal>
    </>
  )
}

export default SecondHandDictionary
